import {
  AiOutlineMinus,
  AiOutlinePlus,
} from "react-icons/ai";
import { useState } from "react";
//? styles
import styles from "./Accordion.module.css";
import Card from "../UI/Card";

const Accordion = (props) => {
  const { title, info } = props;
  const [Info, showInfo] = useState(false);

  const toggleInfoHandler = () => {
    showInfo((prev) => {
      return !prev;
    });
  };
  return (
    <Card
      className={
        styles["question-container__accordion"]
      }
    >
      <div
        className={
          styles[
            "question-container__accordion-question"
          ]
        }
      >
        <h3>{title}</h3>
        <button
          type="button"
          onClick={toggleInfoHandler}
        >
          {!Info && (
            <AiOutlinePlus
              className={styles["icons"]}
            />
          )}
          {Info && (
            <AiOutlineMinus
              className={styles["icons"]}
            />
          )}
        </button>
      </div>
      {!Info ? (
        <p></p>
      ) : (
        <p
          className={
            styles[
              "question-container__accordion-answer"
            ]
          }
        >
          {info}
        </p>
      )}
    </Card>
  );
};

export default Accordion;
